import React from "react";
import { OutlinedInput, Button } from "@material-ui/core";
import ModalComponent from "../../../../Common/ModalComponent";
import RoundButton from "../../../../Common/RoundButton";

function ReferralModal(props: any) {
  const { referralCode, onChangeReferral, onClose, open, onClickNext } = props;
  return (
    <ModalComponent onClose={onClose} open={open}>
      <>
        <p
          style={{
            textAlign: "center",
            color: "#29006c",
            fontWeight: "bold",
            fontSize: "14px",
            marginBottom: "45px",
          }}
        >
          type your referral code
        </p>
        <OutlinedInput
          type="text"
          value={referralCode ? referralCode : ""}
          name="amount"
          onChange={(e) => onChangeReferral(e)}
          placeholder="referral code"
          className="refferalInput"
          inputProps={{ maxLength: 10 }}
        />
        {/* <div
          style={{
            marginTop: "20px",
            position: "relative",
            textAlign: "center",
          }}
        >
          <Button
            style={{
              textAlign: "center",
              backgroundColor: "#ffffff",
              color: "#f40018",
              borderRadius: "20px",
              width: "50%",
            }}
            onClick={() => onClickNext()}
          >
            Next
          </Button>
        </div> */}
        <RoundButton title = "continue" onClick={onClickNext} />
      </>
    </ModalComponent>
  );
}

export default ReferralModal;